import React from "react";
import { Button, Stack } from "@mui/material";
import QuantitySelector from "./QuantitySelector";

const QuantityAndCart = ({
  quantity,
  setQuantity,
  itemsPerSet,
  onAddToCart,
}) => (
  <Stack
    direction="row"
    spacing={1}
    alignItems="center"
    sx={{ width: "100%", justifyContent: "center" }}>
    <QuantitySelector
      value={quantity}
      setValue={setQuantity}
      min={itemsPerSet}
      step={1}
    />
    <Button
      variant="outlined"
      color="primary"
      onClick={onAddToCart}
      sx={{
        height: "100%",
        px: 3,
        borderRadius: "20px",
        textTransform: "none",
        fontWeight: 600,
      }}>
      Add To Cart
    </Button>
  </Stack>
);

export default QuantityAndCart;
